<template>
    <div class="h-full">
        <div class="budgets-hero lg:pb-12 pb-16">
            <Header :scrolled-from-top="scrolledFromTop" />
            <div :class="[scrolledFromTop ? 'pt-60px' : '']">
                <HeroSection :integrations="integrations" />
            </div>
        </div>
        <div class="lg:block hidden">
            <IntegrationsSection :integrations="integrations" />
        </div>
        <FeaturesSection />
        <BenefitsSection />
        <ClientsSection />
        <CtaSection />
        <TestimonialsSection />
        <PricingSection />
        <FaqSection />
        <Footer :languages="languages" />
    </div>
</template>

<script>
import Header from './partials/header.vue';
import HeroSection from './partials/hero-section.vue';
import IntegrationsSection from './partials/integrations-section.vue';
import FeaturesSection from './partials/features-section.vue';
import BenefitsSection from './partials/benefits-section.vue';
import ClientsSection from './partials/clients-section.vue';
import CtaSection from './partials/cta-section.vue';
import TestimonialsSection from './partials/testimonials-section.vue';
import PricingSection from './partials/pricing-section.vue';
import FaqSection from './partials/faq-section.vue';
import Footer from './partials/footer.vue';

export default {
    components: {
        Header,
        HeroSection,
        IntegrationsSection,
        FeaturesSection,
        BenefitsSection,
        ClientsSection,
        CtaSection,
        TestimonialsSection,
        PricingSection,
        FaqSection,
        Footer,
    },

    props: {
        languages: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            scrolledFromTop: false,
            windowTop: 0,
        };
    },

    computed: {
        integrations() {
            const integrations = [
                {
                    imagePath: '/images/marketing/integrations/google-ads.png',
                    name: 'Google Ads',
                },
                {
                    imagePath: '/images/marketing/integrations/youtube-ads.png',
                    name: 'YouTube Ads',
                },
                {
                    imagePath: '/images/marketing/integrations/facebook-ads.png',
                    name: 'Facebook Ads',
                },
                {
                    imagePath: '/images/marketing/integrations/instagram-ads.png',
                    name: 'Instagram Ads',
                },
                {
                    imagePath: '/images/marketing/integrations/linkedin-ads.png',
                    name: 'LinkedIn Ads',
                },
                {
                    imagePath: '/images/marketing/integrations/tiktok-ads.png',
                    name: 'TikTok Ads',
                },
                {
                    imagePath: '/images/marketing/integrations/bing-ads.png',
                    name: 'Bing Ads',
                },
                {
                    imagePath: '/images/marketing/integrations/google-analytics.png',
                    name: 'Google Analytics',
                },
            ];

            return integrations;
        },
    },

    mounted() {
        window.addEventListener("scroll", this.onScroll, true);
    },

    beforeDestroy() {
        window.removeEventListener("scroll", this.onScroll, true);
    },

    watch: {
        windowTop(value) {
            this.scrolledFromTop = value > 0;
        },
    },

    methods: {
        onScroll(e) {
            this.windowTop = window.pageYOffset;
        },
    },
};
</script>
